import { AuthService } from '../../auth/auth.service';
import { WordpressService } from './wordpress.service';

import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { TranslateModule } from '@ngx-translate/core';

import { Observable } from 'rxjs';

export const MODULES = [CommonModule, MatButtonModule, TranslateModule];

@Component({
  selector: 'app-wordpress-teaser',
  templateUrl: 'wordpress-teaser.component.html',
  styleUrls: ['wordpress-teaser.component.scss'],
  imports: [...MODULES],
})
export class WordpressTeaserComponent implements OnInit {
  private wordpressService = inject(WordpressService);
  private auth = inject(AuthService);

  data$: Observable<any> | undefined;
  teaser = signal<string>('');
  url: string = '';

  ngOnInit(): void {
    //this.data$ = this.dataService.getData();
    this.wordpressService.getData().subscribe(data => {
      if (data) {
        this.useTeaser(data);
      }
    });
  }

  useTeaser(wordpressData: any[]): void {
    const language = this.auth.getLanguage();
    const category = this.wordpressService.languageCategory(language);
    for (const dataset of wordpressData) {
      if (dataset.hasOwnProperty('status')) {
        if (dataset.status === 'publish') {
          if (dataset.categories.indexOf(category) >= 0) {
            if (dataset.hasOwnProperty('title')) {
              if (dataset.title.hasOwnProperty('rendered')) {
                this.teaser.set(dataset.title.rendered);
                this.url = dataset.link;
              }
            }
          }
        }
      }
    }
  }
}
